'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weeksAgo.js
// module id = 753
// module chunks = 0